import { messages as validation } from "vee-validate/dist/locale/it.json";
import { countryList } from "@/locales/properNouns";
import messages from "./json/it.json";

export default {
  pl: {
    word: "{n} {word}",
  },
  validation: {
    ...validation,
    credit_card: "Il campo {_field_} deve essere un numero di carta di credito valido",
    required_select: validation.required,
  },
  notificationsText: {
    liked: "A {screenName} è piaciuto il tuo {type}",
    followed: "{screenName} ti ha seguito",
    subscribed: "{screenName} si è abbonato a te per {price}",
    upgradeSubscription: "{screenName} ha aggiornato l'abbonamento a te. Ora il livello di abbonamento è {price}",
    soldPost: "{screenName} ha comprato il tuo post per {price}",
    soldAttachment: "{screenName} ha comprato il tuo allegato per {price}",
    soldEvent: "{screenName} ha prenotato il tuo evento {date} per {price}",
    eventPublished: "Prossimo evento di {screenName}!",
    eventStarted: "L'evento è iniziato",
    eventCancelled: "{screenName} ha cancellato l'evento",
    sendReview: "{screenName} ha lasciato un commento: {review}",
    sendMentionedReview: "{screenName} ti ha risposto: {review}",
    appointmentRequested: "{screenName} ha richiesto {appointmentType} con te",
    appointmentApproved: "{screenName} ha accettato {appointmentType} con te",
    appointmentRejected: "{screenName} ha rifiutato {appointmentType} con te",
    appointmentCancelled: "{screenName} ha cancellato {appointmentType} con te",
    appointmentReminder: "Mancano {timeLeft} all'appuntamento con {screenName}",
    appointmentNoResponse:
      "{screenName} non ha risposto alla tua richiesta di {appointmentType}. Denaro restituito al tuo portafoglio",
    fundraisingFinished: "{goal} completato!",
    fundraisingStarted: "{screenName} ha impostato un {goal}",
    fundraisingDonationCreated: "{screenName} ha donato {amount} a {goal}",
  },
  ...countryList,
  ...messages,
};
